/**
 * About "What they say about us" section. Static markup with the sticky heading
 * and a column of testimonial cards. The card fade-up reveals are class-driven
 * (`.fade-in-move-on-scroll`, `.testimonial-holder`) and wired globally by
 * SiteAnimations.
 */
import type { FC } from 'react'

interface Testimonial {
    quote: string
    name: string
    position: string
}

const TESTIMONIALS: Testimonial[] = [
    {
        quote: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius vel bibendum nulla leo curabitur vulputate imperdiet laoreet. Sit nam pellentesque leo quisque elit. Nibh nunc maecenas in commodo massa adipiscing feugiat. Ante velit facilisis tellus at sagittis, in felis, massa.',
        name: 'Robert Fox',
        position: 'CEO at Dragosh'
    },
    {
        quote: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius vel bibendum nulla leo curabitur vulputate imperdiet laoreet. Sit nam pellentesque leo quisque elit. Nibh nunc maecenas in commodo massa adipiscing feugiat. Ante velit facilisis tellus at sagittis, in felis, massa.',
        name: 'Robert Fox',
        position: 'CEO at Dragosh'
    },
    {
        quote: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius vel bibendum nulla leo curabitur vulputate imperdiet laoreet. Sit nam pellentesque leo quisque elit. Nibh nunc maecenas in commodo massa adipiscing feugiat. Ante velit facilisis tellus at sagittis, in felis, massa.',
        name: 'Robert Fox',
        position: 'CEO at Dragosh'
    }
]

export const Testimonials: FC = () => {
    return (
        <div className='section white-section'>
            <div className='container _6ems'>
                <div className='w-layout-grid grid-8-col'>
                    <div id='w-node-cda9d586-805a-b5d9-2464-749d04e6bfe4-a854ba1a' className='content'>
                        <div className='sticky-text-container'>
                            <div className='fade-in-move-on-scroll'>
                                <h3>What they say about us</h3>
                            </div>
                        </div>
                    </div>
                    <div id='w-node-_418ae47e-5ec8-bbc8-d4c9-3196d04cde7b-a854ba1a' className='testimonial-container'>
                        {TESTIMONIALS.map((testimonial, index) => (
                            <div key={index} className='testimonial-holder'>
                                <div className='content'>
                                    <p className='paragraph-m grey-text---light'>{testimonial.quote}</p>
                                </div>
                                <div className='testimonial-details'>
                                    <div className='testimonial-author-holder'>
                                        <div className='testimonial-profile-picture-container'>
                                            <img
                                                src='/images/Contact-Hero-Image-1.jpg'
                                                loading='lazy'
                                                srcSet='/images/Contact-Hero-Image-1-p-500.jpg 500w, /images/Contact-Hero-Image-1-p-800.jpg 800w, /images/Contact-Hero-Image-1.jpg 1270w'
                                                alt=''
                                                sizes='48px'
                                                className='testimonial-profile-picture'
                                            />
                                        </div>
                                        <div className='testimonial-author-name-holder'>
                                            <p className='paragraph-s no-margins'>{testimonial.name}</p>
                                            <p className='paragraph-s job-position'>{testimonial.position}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
